// extracted by mini-css-extract-plugin
export var subtitle = "_94-2";
export var title = "_94-0";
export var titleNoWrap = "_94-1";